import React from "react";
import "./Player.css";
import Sidebar from "./Sidebar";
import Body from "./Body";
import Footer from './Footer';
function Player({spotify}) {
  return (
    <div className="player">
      <div className="player__body">
        <Sidebar className="sidebar" />
        <Body spotify={spotify}/>
      </div>
      <Footer className="footer"/>
    </div>
  );
}

export default Player;
